import CartUtil from '../../utils/cartUtil';
const init = () => {
    CartUtil.get(false).then((result) => {
        const items = result.items;
        const toDelete = [];
        const toDeleteItems = [];
        const toAddItems = [];
        if (items.length) {
            [...items].map((item) => {
                if (item.product_type === 'eGift Card') {
                    if (item.variant_title.includes('[') && !item.variant_title.includes(dataJs.currentLocale.toLowerCase())) {
                        toDelete.push(item.key);
                        toDeleteItems.push(item);
                    }
                }
            });
            if (toDelete.length > 0) {
                CartUtil.delete(toDelete);
                fetch('/products/egift-card.js')
                    .then((res) => res.json())
                    .then((data) => {
                    toDeleteItems.forEach((toDeleteItem) => {
                        data.variants.find((variant) => {
                            const value = toDeleteItem.variant_title.split('(')[0].split('[')[0];
                            if ((variant.title.includes(value) && variant.title.includes(dataJs.currentLocale.toLowerCase())) || variant.title === value) {
                                toAddItems.push({
                                    id: variant.id,
                                    quantity: toDeleteItem.quantity,
                                });
                                return true;
                            }
                            return false;
                        });
                    });
                    if (toAddItems.length > 0) {
                        CartUtil.add(toAddItems);
                    }
                });
            }
        }
    });
};
export default {
    init,
};
